
<template>
  <el-card class="card-main">
    <el-form ref="searchInfo" :model="searchInfo" class="global-form" :inline="true">
      <el-form-item>
        <el-select v-model="searchInfo.projectId" placeholder="请选择所属项目" filterable clearable>
          <el-option
            v-for="item in projectList"
            :key="item.projectId"
            :label="item.projectName"
            :value="item.projectId"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" class="medium" @click="onSearch">查询</el-button>
      </el-form-item>
    </el-form>
    <el-button class="mb20" @click='onAdd' type="primary" icon='el-icon-plus' v-show="$ButtonShow('PFS_ADD_01')">新增</el-button>
    <el-button class="mb20" @click='onType' type="primary" v-show="$ButtonShow('PFT_ADD_01')">文件类型</el-button>
    <el-table
      class="global-table"
      stripe
      :data="tableData"
      v-loading="loading">
      <el-table-column show-overflow-tooltip label="所属项目">
        <template v-slot="{ row }">
          <span>{{row.projectState === '3' ? getState(row.projectState) + '—' + row.projectName : row.projectName}}</span>
        </template>
      </el-table-column>
      <el-table-column label="项目进场前" class-name="table-header-main" show-overflow-tooltip prop="issueAmountUnrectified" min-width="200px" align="center">
        <el-table-column label="已关联" class-name="table-header-child" show-overflow-tooltip prop="relate1" align="center"></el-table-column>
        <el-table-column label="已提报" class-name="table-header-child" show-overflow-tooltip prop="up1" align="center"></el-table-column>
      </el-table-column>
      <el-table-column label="施工作业中" class-name="table-header-main" show-overflow-tooltip prop="issueAmountUnrectified" min-width="200px" align="center">
        <el-table-column label="已关联" class-name="table-header-child" show-overflow-tooltip prop="relate2" align="center"></el-table-column>
        <el-table-column label="已提报" class-name="table-header-child" show-overflow-tooltip prop="up2" align="center"></el-table-column>
      </el-table-column>
      <el-table-column label="验收完成" class-name="table-header-main" show-overflow-tooltip prop="issueAmountUnrectified" min-width="200px" align="center">
        <el-table-column label="已关联" class-name="table-header-child" show-overflow-tooltip prop="relate3" align="center"></el-table-column>
        <el-table-column label="已提报" class-name="table-header-child" show-overflow-tooltip prop="up3" align="center"></el-table-column>
      </el-table-column>
      <el-table-column label="审计定案" class-name="table-header-main" show-overflow-tooltip prop="issueAmountUnrectified" min-width="200px" align="center">
        <el-table-column label="已关联" class-name="table-header-child" show-overflow-tooltip prop="relate4" align="center"></el-table-column>
        <el-table-column label="已提报" class-name="table-header-child" show-overflow-tooltip prop="up4" align="center"></el-table-column>
      </el-table-column>
      <el-table-column show-overflow-tooltip label="完成度" prop="rate">
        <template v-slot="{ row }">
          <span>{{row.rate ? row.rate + '%' : ''}}</span>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip min-width="120px" label="最近完成时间" prop="recentlyTime"></el-table-column>
      <el-table-column label="操作" width="100px" fixed="right">
        <template v-slot="{ row }">
          <el-button type="text" @click="toDetail(row)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <GlobalPagination
      :total="total"
      :current-page.sync="page"
      :page-size.sync="size"
      @current-change="getList"
      @size-change="getList">
    </GlobalPagination>
    <file-type :isShowType.sync = 'isShowType' @onClose='onSearch'></file-type>
    <el-dialog title="新增文件" width="660px" :visible="addShow" :close-on-click-modal="false" @close='closeDialog'>
      <el-form class="global-form2" :model="info" ref="info" :rules="rules" label-width="90px">
        <el-form-item label="所属项目" prop="projectId">
          <el-select v-model="info.projectId" filterable placeholder="请选择所属项目">
            <el-option
              v-for="item in projectList"
              :key="item.projectId"
              :label="item.projectName"
              :value="item.projectId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间节点" prop="timeNode">
          <el-select
            v-model="info.timeNode"
            placeholder="请选择时间节点"
            filterable
            @change="getTypeList()"
          >
            <el-option
              v-for="(item, index) in nodeList"
              :key="index"
              :label="item"
              :value="index + 1"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="文件类型" prop="fileTypeId">
          <el-select
            v-model="info.fileTypeId"
            placeholder="请选择文件类型"
            filterable
            :disabled="!info.timeNode"
          >
            <el-option
              v-for="item in typeList"
              :key="item.typeId"
              :label="item.typesName"
              :value="item.typeId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上传文件" prop="fileList">
          <UploadFile listType="text" @onSuccess="onSuccess" :slotShow='true' accept="TXT、DOC、XLS、PPT、DOCX、XLSX、PPTX、JPG、PNG、PDF、TIFF、SWF、DWG">
            <template>
              <div class="file">
                <template>
                  <el-link icon="el-icon-upload" type='primary' :underline="false">{{info.fileList.length === 0 ? "点击上传" : '重新上传'}}</el-link>
                  <el-tooltip class="item" effect="dark" content="支持文件格式：TXT、DOC、XLS、PPT、DOCX、XLSX、PPTX、JPG、PNG、PDF、TIFF、SWF、DWG，文件大小不超过100M；" placement="right">
                    <i class="el-icon-question"></i>
                  </el-tooltip>
                </template>
              </div>
            </template>
          </UploadFile>
          <el-form-item v-if="info.fileList.length!==0">
            {{info.fileList[0].fileName}}
          </el-form-item>
        </el-form-item>
        <el-form-item label="文件备注" prop="comments">
          <el-input type="textarea" maxlength="200" placeholder="请输入文件备注" :rows="6" show-word-limit v-model="info.comments"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit" :disabled="submitShow">保存</el-button>
          <el-button @click="closeDialog">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </el-card>
</template>

<script>
import UploadFile from '@/components/uploadFile/Index.vue'
import FileType from './FileType.vue'
export default {
  name: 'List',
  components: {
    UploadFile,
    FileType
  },
  data () {
    return {
      searchInfo: {
        projectId: ''
      },
      tableData: [],
      page: 1,
      size: 10,
      total: 0,
      loading: false,
      addShow: false,
      submitShow: false,
      typeList: [],
      nodeList: ['项目进场前', '施工作业中', '验收完成', '审计定案'],
      isShowType: false,
      info: {
        fileTypeId: '',
        timeNode: '',
        projectId: '',
        comments: '',
        fileList: []
      },
      rules: {
        fileTypeId: [{ required: true, message: '请选择文件类型', trigger: 'change' }],
        timeNode: [{ required: true, message: '请选择时间节点', trigger: 'change' }],
        projectId: [{ required: true, message: '请选择所属项目', trigger: 'change' }],
        fileList: [{ required: true, message: '请上传文件' }]
      }
    }
  },
  computed: {
    projectList () {
      return this.$store.state.projectList
    }
  },
  created () {
    this.getList()
  },
  methods: {
    // 搜索
    onSearch () {
      this.page = 1
      this.getList()
    },
    // 获取列表数据
    getList () {
      this.loading = true
      this.$axios.get(this.$apis.projectFile.selectYhProjectFilesCompilationByList,
        {
          ...this.searchInfo,
          page: this.page,
          size: this.size
        }).then(res => {
        this.tableData = res.list || []
        this.total = res.total || 0
      }).finally(() => {
        this.loading = false
      })
    },
    getTypeList () {
      this.info.fileTypeId = ''
      this.$axios.get(this.$apis.projectFile.selectYhProjectFileTypesByList, {
        timeNode: this.info.timeNode
      }).then(res => {
        this.typeList = res || []
      })
    },
    onType () {
      this.isShowType = true
    },
    onAdd () {
      this.addShow = true
    },
    onSuccess (file) {
      this.info.fileList = [file]
      this.$refs.info.clearValidate()
    },
    toDetail (row) {
      this.$router.push({
        name: 'projectFileDetail',
        params: {
          projectId: row.projectId
        }
      })
    },
    getState (state) {
      const arr = ['', '未开工', '在建', '已移交']
      return arr[Number(state)]
    },
    closeDialog () {
      this.info = {
        fileTypeId: '',
        timeNode: '',
        projectId: '',
        comments: '',
        fileList: []
      };
      (this.$refs.info).resetFields()
      this.addShow = false
      this.onSearch()
    },
    onSubmit () {
      (this.$refs.info).validate((valid) => {
        if (valid) {
          this.submitShow = true
          this.$axios.post(this.$apis.projectFile.insertYhProjectFiles, this.info).then(() => {
            this.$message.success('保存成功')
            this.closeDialog()
          }).finally(() => {
            this.submitShow = false
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
  ::v-deep .el-table--group::after, .el-table--border::after {
    display: none;
  }
  ::v-deep .el-table--border {
    border-width: 0;
    .el-table__cell {
      background-color: transparent !important;
      border-width: 0;
    }
    .el-table__header {
      .table-header-main {
        height: 20px;
        line-height: 20px;
        padding-bottom: 0;
      }
      .table-header-child {
        height: 20px;
        font-size: 11px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #626262;
        line-height: 20px;
        padding-top: 0;
        padding-bottom: 0px;
        .cell{
          background: #FBFBFB;
          text-align: center;
        }
      }
    }
  }
</style>
